import { React, useContext, useState, useRef } from 'react';
import Config from '../shared/Config';
import RenderMarkups from '../shared/RenderMarkups';
import { GlobalContext } from '../state/GlobalContext';

export default function WelcomeStep(){
    const { state, setState } = useContext(GlobalContext);
    const [inputsState, setInputsState] = useState({
        valid: false,
    });
    const ageInput = useRef(null);
    

    function startTest(){
        if(validateInputTextOnSubmit()){
            setState((prevState) => ({
                ...state,
                step: prevState.step + 1,
                shouldScroll: true,
            }))
        }else{

        }
    }

    function validateInputTextOnSubmit(){
        if(ageInput.current.value){
            inputsState.valid = true
            return true;
        }
        return false;
    }
        

    function checkAge(e){
        let userAge = parseInt(e.currentTarget.value);
        
        if(isNaN(userAge)){
            setInputsState({
                valid: false,
            })
        }else{
            setInputsState({
                valid: true,
            })
        }

        if(userAge < 35 || userAge > 65){
            setState({
                ...state,
                incorrectAge: true,
            })
        }else{
            setState({
                ...state,
                incorrectAge: false,
                userAge: userAge,
            })
        }
    }
    
    return (
        // <div className="welcome-screen-wrapper">
        //     <div className='mt-container'>
        //         <div className="mt-row">
        //             <div className="mt-col-md-6 mt-col-12">
        //                 <div className='welcome-screen-wrapper'>
        //                     <div dangerouslySetInnerHTML={RenderMarkups(state.testData.welcome_step.small_heading)}/>
        //                     <div dangerouslySetInnerHTML={RenderMarkups(state.testData.welcome_step.heading)}/>
        //                     <div className='content-wrapper' dangerouslySetInnerHTML={RenderMarkups(state.testData.welcome_step.desc)}/>
        //                 </div>
        //             </div>
        //             <div className="mt-col-md-6 mt-col-12 self-center">
        //                 <img src={state.testData.welcome_step.image} alt="Welcome image"/>
        //                 <div className='age-wrapper' dangerouslySetInnerHTML={RenderMarkups(state.testData.welcome_step.age_text)}/>
        //                 <div className='input-wrapper'>
        //                     <div className='input-and-submit'>
        //                         <input ref={ageInput} type='text' onChange={(e) => {checkAge(e)}} name='menopause_your_age' className='age-input' placeholder={state.testData.welcome_step.age_label}/>
        //                         <button type='button' title={state.testData.welcome_step.button_label} onClick={() => {inputsState.valid && startTest() }} className='start-test'>{state.testData.welcome_step.button_label}<img src={Config('ASSETS_URL')+'/images/arrow-right-long.png'} alt="arrow"/></button>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>            <div className="row">
        <div className='row'>
            <div className='col'>
                <div className='welcome-screen'>
                    <div className='question-card-wrapper'>
                        <div className="inside-wrapper">
                            <div className="row-card">
                                <div className="col-card-icon">
                                    <img src={state.testData.welcome_step.image} alt="Welcome"/>
                                </div>
                                <div className="col-card-content">
                                    <div className='age-text-info' dangerouslySetInnerHTML={RenderMarkups(state.testData.welcome_step.age_text)}/>
                                    <input ref={ageInput} type='text' onChange={(e) => {checkAge(e)}} name='menopause_your_age' className='age-input' placeholder={state.testData.welcome_step.age_label}/>
                                </div>
                            </div>
                        </div>

                        <div className="ui-row">
                            <div className="row-card">
                                <div className="prev-btn-wrapper">
                                    <button onClick={() => {window.location.href=state.testData.welcome_step.back_button_link}} type='button' title={state.testData.general_settings.prev_step}><i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-left-long.png'})`}}></i>{state.testData.general_settings.prev_step}</button>
                                </div>
                                <div className="next-btn-wrapper">
                                    <button title={state.testData.general_settings.prev_step} onClick={() => {inputsState.valid && startTest() }} type='button'>{state.testData.general_settings.next_step}<i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/arrow-right-long.png'})`}}></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    )
}
